<ion-header>
  <ion-toolbar mode="ios">
    <ion-button (click)="close()" fill="clear" color="dark" class="ion-no-padding">
      <ion-icon slot="icon-only" name="chevron-back"></ion-icon>
    </ion-button>
    <ion-title class="ion-no-padding">
      <ion-img [src]="dataServ.rData.dark_logo" *ngIf="dataServ.rData.dark_logo[0]"></ion-img>
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>

  <ion-grid class="form" *ngIf="!urlLink">

    <ion-row>
      <ion-col size="12">
        <ion-text color="primary" class="ion-text-center">
          <h1><b>{{'Reservation' | translate}}</b></h1>
        </ion-text>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size="6">
        <ion-item>
          <ion-label position="stacked">{{'Check-in' | translate}}
          </ion-label>
          <ion-datetime display-format="DD.MM.YYYY" [(ngModel)]="checkIn"></ion-datetime>
        </ion-item>
      </ion-col>

      <ion-col size="6">
        <ion-item>
          <ion-label position="stacked">{{'Check-out' | translate}}
          </ion-label>
          <ion-datetime display-format="DD.MM.YYYY" [(ngModel)]="checkOut"></ion-datetime>
        </ion-item>
      </ion-col>

      <ion-col size="6">
        <ion-item>
          <ion-label position="stacked">{{'Adult' | translate}}
          </ion-label>
          <ion-select [(ngModel)]="adult">
            <ion-select-option [value]="i+1" *ngFor="let a of [].constructor(9); let i = index">{{i+1}}
            </ion-select-option>
          </ion-select>
        </ion-item>
      </ion-col>

      <ion-col size="6">
        <ion-item>
          <ion-label position="stacked">{{'Child' | translate}}
          </ion-label>
          <ion-select [(ngModel)]="children">
            <ion-select-option [value]="i" *ngFor="let a of [].constructor(9); let i = index">{{i}}
            </ion-select-option>
          </ion-select>
        </ion-item>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size="12">
        <ion-button (click)="openReservation()" expand="block">
          {{'Search' | translate}}
        </ion-button>
      </ion-col>
    </ion-row>


  </ion-grid>

  <iframe [src]="urlLink" *ngIf="urlLink"></iframe>
</ion-content>